import { AuResourceName } from "@arrowsup/platform-dtos";
import { useDataProvider } from "react-admin";
import { useQuery } from "@tanstack/react-query";
import { useEffectiveOrgId } from "../auth/use-effective-org-id";

export const useConversionFilters = () => {
  const dataProvider = useDataProvider();
  const orgId = useEffectiveOrgId();
  return useQuery({
    queryKey: ["conversion-filter" satisfies AuResourceName, orgId],
    queryFn: ({ signal }) =>
      dataProvider.getList("conversion-filter" satisfies AuResourceName, {
        sort: {
          field: "name",
          order: "ASC",
        },
        pagination: {
          page: 1,
          perPage: 1000,
        },
        signal,
      }),
  });
};
